import { render, staticRenderFns } from "./ShopThirdOrder.vue?vue&type=template&id=6e54c154&scoped=true&"
import script from "./ShopThirdOrder.vue?vue&type=script&lang=js&"
export * from "./ShopThirdOrder.vue?vue&type=script&lang=js&"
import style0 from "./ShopThirdOrder.vue?vue&type=style&index=0&id=6e54c154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e54c154",
  null
  
)

export default component.exports